<div class="p-d-flex p-ai-center">
    <h4 class="p-d-inline" style="margin-right: 0.5rem;">{{field.label}}:</h4>
    <div class="color-preview-container">
      <div [ngStyle]="{'background-color': record[field.key]}" class="color-preview"></div>
    </div>
    <span style="margin-left: 0.5rem;">{{record[field.key]}}</span>
</div>
